import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';

const styles = {
  aboutUsSection: {
    textAlign: 'left',
    margin: '30px',
  },
  row: {
    display: 'flex',
  },
  title: {
    transition: '.3s',
    fontWeight: '300',
    fontFamily: '"Montserrat", "Helvetica", "Arial", sans-serif',
    fontStyle: 'normal',
    color: '#000000',
    fontSize: '60px',
    lineHeight: '1.3',
    letterSpacing: '0px',
  },
  infoWrapper: {
    paddingTop: '50px',
    fontSize: '16px',
    fontFamily: '"Montserrat", "Helvetica", "Arial", sans-serif',
  },
  text: {
    fontSize: '20px',
    fontFamily: '"Montserrat", "Helvetica", "Arial", sans-serif',
    fontWeight: '400',
    margin: '20px 0',
  },
  gradientButton: {
    marginTop: '1rem',
    fontSize: '14px',
  },
  imageContainer: {
    float: 'right',
  },
};

class AboutUs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      responseText: '',
      disableButton1: false,
      disableButton2: false,
      disableButton3: false,
      disableButton4: false,
      correct: <div />,
      firstQuestion: true,
    };
  }

  handleButton = (buttonName) => {
    if (this.state[buttonName]) {
      this.setState({
        [buttonName]: false,
      });
    } else {
      this.setState({
        [buttonName]: true,
      });
    }
  };

  handleText = (text) => {
    this.setState({
      responseText: text,
    });
  };

  handleCorrect = (html) => {
    this.setState({
      correct: html,
    });
  };

  render() {
    const { classes } = this.props;
    if (this.state.firstQuestion) {
      return (
        <div style={styles.aboutUsSection}>
          <Grid container spacing={24}>
            <Grid item xs={4}>
              <span className={classes.imageContainer}>
                <img src={require('./shutterstock_151427939.png')} />
              </span>
            </Grid>
            <Grid item xs={4}>
              <div className={classes.row}>
                <div className={classes.infoWrapper}>
                  <div className={classes.title}>Who We Are</div>
                  <div className={classNames(classes.title, classes.text)}>
                    <List component="nav">
                      <ListItem
                        button
                        disabled={this.state.disableButton1}
                        onClick={() => {
                          this.handleButton('disableButton1');
                          this.handleText(
                            <div>
                              <h1>Not Quite!</h1>
                              <p>
                                Creating awesome products and dreaming up the newest innovations is
                                part of what we do, but not everything!
                              </p>
                            </div>,
                          );
                        }}
                      >
                        <ListItemText primary="A. a diverse team of dreamers and creators" />
                      </ListItem>
                      <ListItem
                        button
                        disabled={this.state.disableButton2}
                        onClick={() => {
                          this.handleButton('disableButton2');
                          this.handleText(
                            <div>
                              <h1>Almost There!</h1>
                              <p>This is true.. in addition to all of the others..</p>
                            </div>,
                          );
                        }}
                      >
                        <ListItemText primary="B. a small team innovating the next big things" />
                      </ListItem>
                      <ListItem
                        button
                        disabled={this.state.disableButton3}
                        onClick={() => {
                          this.handleButton('disableButton3');
                          this.handleText(
                            <div>
                              <h1>So Close!</h1>
                              <p>This is a trick question. We are the original hard-core nerds.</p>
                            </div>,
                          );
                        }}
                      >
                        <ListItemText primary="C. a group of extremely hard-core nerds" />
                      </ListItem>
                      <ListItem
                        button
                        disabled={this.state.disableButton4}
                        onClick={() => {
                          this.handleText(
                            <div>
                              <h1>Correct!</h1>
                              <p>You guessed it! All of the above answers apply to us.</p>
                            </div>,
                          );
                          this.handleCorrect(
                            <div>
                              <Button
                                variant="contained"
                                color="primary"
                                className={classes.gradientButton}
                                aria-label="Update"
                                onClick={() => {
                                  this.handleCorrect(<div />);
                                  this.handleText('');
                                  if (this.state.disableButton1) {
                                    this.handleButton('disableButton1');
                                  }
                                  if (this.state.disableButton2) {
                                    this.handleButton('disableButton2');
                                  }
                                  if (this.state.disableButton3) {
                                    this.handleButton('disableButton3');
                                  }
                                  this.handleButton('firstQuestion');
                                }}
                              >
                                Next Question
                              </Button>
                            </div>,
                          );
                        }}
                      >
                        <ListItemText primary="D. all of the above" />
                      </ListItem>
                    </List>
                    {this.state.responseText}
                    {this.state.correct}
                  </div>
                </div>
              </div>
            </Grid>
            <Grid item xs={4} />
          </Grid>
        </div>
      );
    }
    return (
      <div style={styles.aboutUsSection}>
        <Grid container spacing={24}>
          <Grid item xs={4}>
            <span className={classes.imageContainer}>
              <img src={require('./aboutUsPic.jpg')} />
            </span>
          </Grid>
          <Grid item xs={4}>
            <div className={classes.row}>
              <div className={classes.infoWrapper}>
                <div className={classes.title}>What was our old team name?</div>
                <div className={classNames(classes.title, classes.text)}>
                  <List component="nav">
                    <ListItem
                      button
                      disabled={this.state.disableButton1}
                      onClick={() => {
                        this.handleButton('disableButton1');
                        this.handleText(
                          <div>
                            <h1>Nope!</h1>
                            <p>555 is our current team name.</p>
                          </div>,
                        );
                      }}
                    >
                      <ListItemText primary="A. 555" />
                    </ListItem>
                    <ListItem
                      button
                      disabled={this.state.disableButton2}
                      onClick={() => {
                        this.handleButton('disableButton2');
                        this.handleText(
                          <div>
                            <h1>So Close!</h1>
                            <p>You got the eye theme right alright.</p>
                          </div>,
                        );
                      }}
                    >
                      <ListItemText primary="B. Cornea" />
                    </ListItem>
                    <ListItem
                      button
                      disabled={this.state.disableButton3}
                      onClick={() => {
                        this.handleText(
                          <div>
                            <h1>Correct!</h1>
                            <p>My Atom code is colorful like my IRIS</p>
                          </div>,
                        );
                      }}
                    >
                      <ListItemText primary="C. Iris" />
                    </ListItem>
                    <ListItem
                      button
                      disabled={this.state.disableButton4}
                      onClick={() => {
                        this.handleButton('disableButton4');
                        this.handleText(
                          <div>
                            <h1>Nada!</h1>
                            <p>Wow you really think our team is that new?</p>
                          </div>,
                        );
                      }}
                    >
                      <ListItemText primary="D. None" />
                    </ListItem>
                  </List>
                </div>
                <div>
                  {this.state.responseText}
                  {this.state.correct}
                </div>
              </div>
            </div>
          </Grid>
          <Grid item xs={4} />
        </Grid>
      </div>
    );
  }
}

export default withStyles(styles)(AboutUs);
